// src/pages/Dashboard/components/CasePanel/ClientDataSection/ClientDataDisplay.js

import React from 'react';

/**
 * Display dos dados do cliente com botões de ação
 * @param {string} dadosCliente - Dados formatados do cliente
 * @param {function} onReload - Callback para recarregar dados
 * @param {function} onCopy - Callback para copiar dados
 */
const ClientDataDisplay = ({ dadosCliente, onReload, onCopy }) => {
  return (
    <div className="dados-cliente-display">
      <div className="dados-cliente-actions">
        <button 
          className="btn-action-dashboard btn-reload-dashboard"
          onClick={onReload}
          title="Recarregar dados"
        >
          🔄 Recarregar
        </button>
        <button 
          className="btn-action-dashboard btn-copy-dashboard"
          onClick={onCopy}
          title="Copiar dados"
        >
          📋 Copiar
        </button>
      </div>
      <textarea 
        className="dados-cliente-texto"
        value={dadosCliente}
        readOnly
      />
    </div>
  );
};

export default ClientDataDisplay;